<template>
  <v-tooltip
    max-width="300px"
    bottom
  >
    <template #activator="{ on, attrs }">
      <v-btn
        :style="textStyle"
        v-bind="attrs"
        href="#"
        text
        plain
        :disabled="disabled"
        @click.prevent="$emit('click')"
        v-on="on"
      >
        <slot>{{ text }}</slot>
        <span
          v-if="icon"
          class="small"
        >
          <i :class="icon" />
        </span>
      </v-btn>
    </template>
    <span>
      <slot name="tooltip">{{ tooltipText }}</slot>
    </span>
  </v-tooltip>
</template>
<script>
export default {
  props: {
    tooltipText: {
      type: String,
      required: false,
      default: 'Acessar'
    },
    text: {
      type: String,
      required: false,
      default: 'Acessar'
    },
    icon: {
      type: [String,Boolean],
      default: 'fa fa-chevron-right'
    },
    disabled:{
      type: Boolean,
      default: false,
    },
    textStyle :{
      type: String,
      default: ''
    }
  }
}
</script>
<style scoped>
  .v-btn {
      letter-spacing: 0;
  }
</style>
